import React from 'react'
import { useSelector } from 'react-redux'

function InfoBar() {

    const room = useSelector(state => state.room)

    return (
        <div className = "infobar-container">
            <h2 >{room.name}</h2>
        </div>
    )
}

export default InfoBar
